/**
 * Gravity Forms integration.
 */

/** Dependencies -------------------------------------------- */

/** Utils --------------------------------------------------- */

export default class GravityFormsIntegration {

    /** Class setup ----------------------------------------- */

    constructor( config = {} ) {

        this.config = Object.assign(
            {
				formSelector            : '.gform_wrapper > form',
				adminLabelDataAttr      : 'admin-label',
				adminLabelDatasetKey    : 'adminLabel',
				sessionStorageItemPrefix: 'gravityFormsIntegration',
				searchParamsToTrack     : [ 'utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content' ]
            },
            config
        )

		this.forms = document.querySelectorAll( this.config.formSelector )

    }

	/** Initialization -------------------------------------- */

    init() {

		// Set all UTM parameters as session storage, if they exist

		const url          = new URL( window.location.href )
		const urlSearchParams = url.searchParams

		for ( const searchParamToTrack of this.config.searchParamsToTrack ) {

			const urlSearchParam = urlSearchParams.get( searchParamToTrack )

			if ( ! urlSearchParam ) continue

			this.setStoredSearchParam( searchParamToTrack, urlSearchParam )
		}

		// Now, if there are forms, fill their corresponding inputs
		// This happens by way of the admin field data attribute

		if ( ! this.forms.length ) return

		for ( const searchParamToTrack of this.config.searchParamsToTrack ) {
			
			for ( const form of this.forms ) {

				const searchParamInputs = form.querySelectorAll( `[data-${this.config.adminLabelDataAttr}="${searchParamToTrack}"]` )

				for ( const searchParamInput of searchParamInputs ) {
					searchParamInput.value = this.getStoredSearchParam( searchParamToTrack )
				}
			}
		}		
	}

	/** Utilities ------------------------------------------- */

	getStoredSearchParam( key ) {
		return sessionStorage.getItem( `${this.config.sessionStorageItemPrefix}-${key}` )
	}

	setStoredSearchParam( key, value = '' ) {

		if ( ! value ) return null
		return sessionStorage.setItem( `${this.config.sessionStorageItemPrefix}-${key}`, value )
	}
}